/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompositionDto } from './compositionDto';


export interface AgreementDto { 
    id?: number | null;
    agreementCategoryId?: number;
    isExtraEnabled?: boolean | null;
    dishLimitNumber?: number;
    endDate?: string;
    startDate?: string;
    companyId?: number;
    shopId?: number | null;
    pointNumber?: number | null;
    pointPrice?: number | null;
    valueLimit?: number | null;
    companyFlatAmount?: number | null;
    employeeFlatAmount?: number | null;
    compositions?: Array<CompositionDto> | null;
}

